<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 返回按钮 -->
    <div
      class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor"
      @click="$router.push('/shebei/photoManage')"
    >
      <i class="el-icon-arrow-left fw-600"></i>
      返回
    </div>
    <el-form ref="form" :rules="rules" :model="form" label-width="80px">
      <el-form-item label="证件名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入证件名称"></el-input>
      </el-form-item>
      <el-form-item label="证件类型" prop="type">
        <el-radio-group v-model="form.type">
          <el-radio label="图片"></el-radio>
          <el-radio label="PDF"></el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="上传图片" prop="img">
        <el-upload
          :action="'#'"
          list-type="picture-card"
          :before-upload="beforeAvatarUpload"
          :auto-upload="true"
          :accept="'image/*'"
          v-model="form.img"
          :show-file-list="false"
          :http-request="uploadFile"
        >
          <img :src="form.img" v-if="form.img" class="img-feng" />
          <i v-else class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="文件导入" prop="file">
        <el-upload
          ref="upload"
          :action="'#'"
          :limit="1"
          :multiple="false"
          :auto-upload="false"
          accept=".pdf"
          :file-list="form.file"
          :http-request="uploadFile2"
          :on-change="fileChange"
          :on-exceed="handleExceed"
          :on-remove="handleRemove"
        >
          <el-button size="small" type="primary">选择PDF文件</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="生效设备" prop="equipment">
        <el-select
          multiple
          filterable
          v-model="form.equipment"
          placeholder="请选择生效设备"
        >
          <el-option label="区域一" value="shanghai"></el-option>
          <el-option label="区域二" value="beijing"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注">
        <el-input
          type="textarea"
          v-model="form.desc"
          placeholder="请输入备注"
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="save('form')">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      form: {
        name: "",
        type: "图片",
        img: "",
        file: [],
        desc: "",
        imgUpadate: "",
        equipment: [],
      },
      changeHeadImgform: {
        headUrl: "",
      },
      rules: {
        name: [{ required: true, message: "请输入证件名称", trigger: "blur" }],
        type: [{ required: true, message: "请选择证件类型", trigger: "blur" }],
        img: [{ required: true, message: "请上传图片", trigger: "blur" }],
        file: [{ required: true, message: "请上传文件", trigger: "blur" }],
        equipment: [{ required: true, message: "请选择设备", trigger: "blur" }],
      },
    };
  },
  methods: {
    // 保存按钮
    save(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          this.$refs.upload.submit();
        } else {
          return false;
        }
      });
    },

    // 图片
    beforeAvatarUpload(file) {
      console.log(file, 231232);
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
      }
      return isLt2M;
    },

    /* 自定义上传 */
    uploadFile(params) {
      // 通过 FormData 对象上传文件
      let formData = new FormData();
      formData.append("files", params.file);

      /* 在这里发请求就行了 */
      /* ------------------------------------ */
      this.$api.shebei.uploadHeader(formData).then((res) => {
        if (res.code === 200) {
          console.log(res, "上传图片");
          this.form.img = res.data[0];
          console.log(this.form.img, "this.form.img");
          this.form.imgUpadate = [];
          this.form.imgUpadate.push({ url: res.data[0] });
        }
      });
      /* ------------------------------------ */

      // // 成功失败都删除文件;
      // this.fileList.splice(-1, 1);
    },

    // 文件
    /* 自定义上传 */
    uploadFile2(params) {
      // 通过 FormData 对象上传文件
      let formData = new FormData();
      formData.append("file", params.file);

      /* 在这里发请求就行了 */
      /* ------------------------------------ */

      // this.$api.waterCard
      //   .topUpload({
      //     file: formData,
      //     payMoney: this.tabelForm.payPrice,
      //     giveMoney: this.tabelForm.givePrice,
      //     packageId: this.tabelForm.menu,
      //     payType: 5,
      //     orderType: 2,
      //   })
      //   .then((res) => {
      //     if (res.code === 200) {
      //       console.log(this.form.file, "this.form.file");
      //       //   this.addVisible = false;
      //       handleAlert("导入成功", "success");
      //       this.tabelForm = {
      //         tabelTopWay: "套餐充值",
      //         menu: "",
      //         payPrice: "",
      //         givePrice: "",
      //         intoPrice: "",
      //       };
      //       this.disBtn = false;
      //       this.cardNum = res.data.cardNum;
      //       this.payMoney = res.data.payMoney;
      //       this.excelShow = false;
      //       this.batch = res.data.data;
      //       this.getTable();
      //     }
      //   });
      /* ------------------------------------ */
      // 成功失败都删除文件;
      this.form.file.splice(-1, 1);
    },
    /* 文件上传后的钩子  在此做校验 */
    fileChange(file, fileList) {
      console.log(file, "file");
      console.log(fileList, "fileList");

      this.file = file;
      // console.log(fileList);
      this.form.file = fileList;
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      //   if (extension !== "xlsx" && extension !== "xls") {
      //     this.$message.warning("只能上传后缀是.xlsx和xls的文件");
      //     fileList.splice(-1, 1); //移除错误文件
      //     return;
      //   }
      if (extension !== "pdf") {
        this.$message.warning("只能上传后缀是.pdf的文件");
        fileList.splice(-1, 1); //移除错误文件
        return;
      }
      // 文件大小校验
      const size = file.size / 1024 / 1024;
      if (size > 5) {
        this.$message.warning("文件大小不得超过5M");
        fileList.splice(-1, 1); //移除错误文件
        return;
      }
      this.fileName = file.name;
    },
    /* 超出个数 */
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    // 导入的文件删除
    handleRemove(file, fileList) {
      console.log(file, fileList, "删除");
      this.form.file = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.el-input {
  width: 40%;
}
.el-select {
  width: 40% !important;
}

.el-textarea {
  width: 40% !important;
}
.img-feng {
  width: 140px;
  height: 140px;
}

/deep/ .el-upload-list__item {
  width: 40% !important;
}
</style>
